<div
  class="flex items-center gap-2 rounded border leading-4 font-montserrat text-[12px] border-green-regular bg-green-light text-green-regular font-normal px-2 py-1"
  [ngClass]="class">
    {{ label | translate }}
    <i class="fa-solid fa-xmark cursor-pointer" (click)="onDismiss()"></i>
</div>
